module.exports = __webpack_public_path__ + "static/media/eve-usdc.afee570e.svg";